import { ArrowRight, ReceiptEuro } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DepotForm } from '@/components/billing/BillingPipeline';
import { useLatestActiveRun } from '@/hooks/useLatestActiveRun';
import { moisLabel } from '@/lib/billing-format';

export function BillingView() {
  const navigate = useNavigate();
  const { data: activeRun } = useLatestActiveRun();

  const openRun = (runId: string) =>
    navigate(`/o/admin/billing/${runId}`);

  return (
    <div className="space-y-8">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-bold text-slate-900">
          <ReceiptEuro className="h-6 w-6 text-slate-400" />
          Facturation
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Import des annexes Sewan, contrôle par centre de facturation, puis
          publication des Détail dans les Factures de chaque client. Les fichiers
          déposés ne sont <strong>pas conservés</strong>.
        </p>
      </div>

      {activeRun && (
        <button
          type="button"
          onClick={() => openRun(activeRun.id)}
          className="flex w-full max-w-2xl items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 px-5 py-4 text-left transition-colors hover:bg-amber-100/70"
        >
          <div>
            <p className="text-sm font-medium text-amber-900">
              Import en cours — {moisLabel(activeRun.periodMonth, activeRun.periodYear)}
            </p>
            <p className="text-xs text-amber-700">
              {activeRun.status === 'publishing'
                ? 'Publication en cours, reprendre le suivi.'
                : 'Analysé, en attente de publication.'}
            </p>
          </div>
          <span className="flex items-center gap-1 text-sm font-medium text-amber-900">
            Reprendre <ArrowRight className="h-4 w-4" />
          </span>
        </button>
      )}

      <DepotForm onDone={openRun} />
    </div>
  );
}
